const acceptDocuments = ['DRIVERS_LICENCE', 'PASSPORT', 'NATIONAL_ID'];

export const findRegistrationDocuments = (documentSources) => {
  return documentSources.filter(({ key }) => acceptDocuments.includes(key));
};
